<template>
  <div class="add-components-container">
    <div class="menu-tab">
      <el-row>
        <el-button size="mini" @click="addComponentCate">添加分类</el-button>
        <el-button type="primary" size="mini" @click="toggleSelection(true)"
          >全选</el-button
        >
        <el-button type="success" size="mini" @click="toggleSelection(false)"
          >取消全选</el-button
        >
        <el-button type="info" size="mini" @click="delAll">删除</el-button>
      </el-row>
    </div>
    <el-table
    :height="height"
      v-loading="Loading"
      ref="multipleTable"
      :data="
        tableData.filter(
          (data) =>
            !search || data.name.toLowerCase().includes(search.toLowerCase())
        )
      "
      class="table-content"
      style="width: 100%"
      @selection-change="selectChange"
    >
      <el-table-column type="selection" width="55"> </el-table-column>
      <el-table-column label="name" prop="name"> </el-table-column>
      <el-table-column label="icon" prop="icon">
        <template slot-scope="scope">
          <el-image style="width: 50px; height: 50px" :src="scope.row.icon">
          </el-image>
        </template>
      </el-table-column>
      <el-table-column align="right">
        <template slot="header" slot-scope="scope">
          <el-input v-model="search" size="mini" placeholder="输入关键字搜索" />
        </template>
        <template slot-scope="scope">
          <el-button size="mini" @click="handleEdit(scope.$index, scope.row)"
            >Edit</el-button
          >
          <el-button
            size="mini"
            type="danger"
            @click="handleDelete(scope.$index, scope.row)"
            >Delete</el-button
          >
        </template>
      </el-table-column>
    </el-table>

    <el-dialog
      :title="currentType == diaglogType.add ? '添加组件类别' : '编辑组件类别'"
      :modal-append-to-body="false"
      :visible.sync="dialogVisible"
      width="30%"
      :destroy-on-close="true"
    >
      <div style="margin: 20px"></div>
      <el-form
        :label-position="labelPosition"
        label-width="80px"
        :model="formData"
        :rules="rules"
        ref="form"
      >
        <el-form-item label="封面">
          <el-upload
            class="upload-demo"
            drag
            :action="
              currentType == diaglogType.add ? urls.addUrl : urls.editUrl
            "
            :multiple="false"
            :headers="headers"
            name="file"
            :limit="1"
            :accept="accept"
            :auto-upload="false"
            ref="upload"
            :data="formData"
            :file-list="filelist"
            :on-success="success"
            :on-error="error"
            :http-request="uploadHttpRequest"
            :before-upload="beforeUpload"
          >
            <i class="el-icon-upload"></i>
            <div class="el-upload__text">
              将文件拖到此处，或<em>点击上传</em>
            </div>
            <div class="el-upload__tip" slot="tip">
              只能上传jpg/png文件，且不超过5M
            </div>
          </el-upload>
        </el-form-item>
        <el-form-item label="分类名称" prop="name">
          <el-input v-model="formData.name"></el-input>
        </el-form-item>
        <el-form-item label="公开/私有">
          <el-switch
            active-value="1"
            inactive-value="0"
            v-model="formData.CraftType"
            active-color="#13ce66"
            inactive-color="#ff4949"
          >
          </el-switch>
        </el-form-item>
      </el-form>

      <span slot="footer" class="dialog-footer">
        <el-button @click="dialogVisible = false">取 消</el-button>
        <el-button
          type="primary"
          v-if="currentType == diaglogType.add"
          @click="confirm"
          >确 定</el-button
        >
        <el-button
          type="primary"
          v-if="currentType == diaglogType.edit"
          @click="editConfirm"
          >确 定</el-button
        >
      </span>
    </el-dialog>
  </div>
</template>
  <script>
import jsCookie from "js-cookie";
const token = jsCookie.get("token");
import { IMG_SIZE } from "../type/config";
import * as Axios from "axios";
const diaglogType = {
  add: "1",
  edit: "2",
};
export default {
  data() {
    return {
      height:'800px',
      Loading: false,
      dialogVisible: false,
      labelPosition: "top",
      currentType: diaglogType.add,
      headers: {
        Authorization: "Bearer " + token,
      },
      urls: {
        addUrl: "api/CraftComponentCatalog",
        editUrl: "api/CraftComponentCatalog/%s",
      },
      diaglogType: diaglogType,
      filelist: [],
      formData: {
        name: "",
        CraftType: 0,
      },
      accept: "image/png, image/jpeg",
      rules: {
        name: [{ required: true, message: "请输入分类名称", trigger: "blur" }],
      },
      tableData: [],
      search: "",
    };
  },
  created() {
    this.topo = this.$Core.getProvider("TechnologyTopo");
    this.getDataList();
    this.height = window.innerHeight - 100 + "px";
  },

  methods: {
    beforeUpload(file){
        if(file.size > IMG_SIZE){
            this.$message.error('图片大小不能超过5M');
            return false
        }
        return true
    },
    async getDataList() {
      this.Loading = true;
      let data = await this.topo.components.getCate();
      this.Loading = false;
      this.tableData = data;
    },
    uploadHttpRequest(evt) {
      console.log(evt);
      let formData = new FormData();
      formData.append("file", evt.file);
      formData.append("name", evt.data.name);
      formData.append("Data", evt.data.Data);

      // 禁止上传超过5M的图片
      if (evt.file.size > this.size) {
        this.$message.error("图片大小不能超过5M");
        return;
      }
      if (this.currentType == diaglogType.edit) {
        Axios.put(this.urls.editUrl, formData, {
          headers: this.headers,
        })
          .then((res) => {
            evt.onSuccess(res.data);
          })
          .catch((err) => {
            evt.onError(err.data);
          });
      } else {
        Axios.post(this.urls.addUrl, formData, {
          headers: this.headers,
        })
          .then((res) => {
            evt.onSuccess(res.data);
          })
          .catch((err) => {
            evt.onError(err.data);
          });
      }
    },
    addComponentCate() {
      this.currentType = diaglogType.add;
      this.formData.name = "";
      this.dialogVisible = true;
    },
    handleEdit(index, row) {
      console.log(index, row);
      this.urls.editUrl = this.urls.editUrl.replace("%s", row.id);
      this.currentType = diaglogType.edit;
      this.formData.id = row.id;
      this.formData.name = row.name;
      this.dialogVisible = true;
    },
    handleDelete(index, row) {
      if (!confirm("确定删除吗？")) return;
      this.topo.components
        .delCate(this.tableData[index].id)
        .then((res) => {
          if (res.success) {
            this.tableData.splice(index, 1);
          } else {
            this.$message.error(res.message);
          }
        })
        .catch((err) => {
          this.$message.error(err.message);
        });
    },
    // 全选或取消全选
    toggleSelection(rows) {
      if (rows) {
        this.tableData.forEach((row) => {
          this.$refs.multipleTable.toggleRowSelection(row);
        });
      } else {
        this.$refs.multipleTable.clearSelection();
      }
    },
    handleSelectionChange(val) {
      this.multipleSelection = val;
    },
    success(res) {
      if (res.success) {
        this.dialogVisible = false;
      } else {
        this.$message.error(res.message);
      }
      this.getDataList();
    },
    error(err) {
      this.$message.error("网络请求错误");
    },
    // 确认编辑
    editConfirm() {
      if (
        !this.$refs.upload.uploadFiles ||
        !this.$refs.upload.uploadFiles.length
      ) {
       this.$message.error("请上传封面");
      } else {
        this.$refs.form.validate((valid) => {
          if (valid) {
            this.$refs.upload.submit();
          } else {
            console.log("error submit!!");
            return false;
          }
        });
      }
    },
    // 确认上传
    confirm() {
      if (
        !this.$refs.upload.uploadFiles ||
        !this.$refs.upload.uploadFiles.length
      ) {
        this.$message.error("请上传文件");
        return;
      }
      this.$refs.form.validate((valid) => {
        if (valid) {
          this.$refs.upload.submit();
        } else {
          console.log("error submit!!");
          return false;
        }
      });
    },
    selectChange(e) {
      this.selectList = e;
    },
    //   删除所有
    delAll() {
      if (!confirm("确认删除所有数据？")) return;
      this.Loading = true;
      let all = [];
      this.selectList.forEach(async (item, index) => {
        all.push(this.topo.components.delCate(item.id));
      });

      Promise.all(all)
        .then((res) => {
          this.Loading = false;
          this.$message.success("删除成功");
          this.getDataList();
          res.forEach(item=>{
            if(!item.success){
                this.$message.error(item.message);
            }
          })
        })
        .catch((_) => {
          this.Loading = false;
        });
    },
  },
};
</script>
  <style lang="scss" scoped>
.table-content {
  margin-top: 20px;
  background: #323232;
}
</style>